import React from 'react';
import {getChallengeContainer} from './GenericChallengeContainer.js';


const getSteps = (t) => [
    {type:'Confirm',   props:{buttonText:t('challenges:::Start Challenge')}},
    {type:'AllDay',    props:{withMax:false}, assign:{'action':'action'}, action:function(vars){ return {action:vars.action} }},
];

const AllDayChallengeContainer = getChallengeContainer(getSteps, '/virtual/all-day-challenge', {noCompleteScreen:true});

export default AllDayChallengeContainer;



// WEBPACK FOOTER //
// ./src/modules/challenges/types/AllDayChallengeContainer.js